import Error from '../model/Error';
import axios from 'axios';

export default class LetterDraftRepository {
    static findAll(clubId, entity) {
        const params = {
            entity,
        };

        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/drafts`, { params })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
